import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Content = ({ className, children }: Props) => {
    return (
        <div
            className={cn(
                "tw:bg-background tw:rounded-t tw:flex tw:flex-col tw:items-start tw:max-h-150",
                className
            )}
        >
            {children}
        </div>
    );
};
